// Charge la base commune
import './common.js'

// Scripts librairies
/* global Waypoint */
import 'waypoints/lib/jquery.waypoints.min.js'
import { dtectMap } from './js/libs/utils.js'
import { agenciesMap } from './js/components/agenciesMap.js'

// Styles custom
import './scss/pages/agencies.scss'
import './scss/components/contactForm'

// rafraîchissement
function r () {
  Waypoint.refreshAll()
}

// Pajination
async function getPajination () {
  import(/* webpackChunkName: "pajination" */ './js/components/pajination.js').then(() => {
    r()
  })
}

// Contact Form
async function getCForm ($f) {
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    $f.load(false)
  })
}

// Agency autocomplete
async function getAgencyAutocomplete ($f) {
  import(/* webpackChunkName: "quick-agency-search-form" */ './js/components/quick-agency-search-form.js').then(
    (module) => {
      const form = module.qasForm
      form.init($f)
    }
  )
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion des carousel
  const $f = $('div.owl-carousel')
  if ($f.length) {
    $f.waypoint(
      function () {
        this.destroy()
      },
      {
        offset: '100%'
      }
    )
  }

  // gestion des scrollbars améliorées
  const $p = $('.pajinate')
  if ($p.length) {
    $p.waypoint(
      function () {
        getPajination()
        this.destroy()
      },
      {
        offset: '100%'
      }
    )
  }

  // formulaire de contact
  const $cf = $('form[name="cForm"]')
  if ($cf.length) {
    $cf.waypoint(
      function () {
        $cf.load()
        getCForm($cf)
        this.destroy()
      },
      {
        offset: '100%'
      }
    )
  }

  // filtres des agences autocomplete
  $('form[name="qasForm"] input[name="search"]').on('click', function () {
    $(this).blur().off('click').attr('disabled', '')
    getAgencyAutocomplete($(this).parents('form'))
  })

  // refresh waypoints au chargement d'une image
  $('.lazyload').on('lazyloaded', () => {
    r()
  })
  setTimeout(function () {
    r()
  }, 500)

  // à exécuter une fois la GMap API correctement chargée
  dtectMap(function () {
    // gestion de la carte des agences
    const $c5 = $('#map-agencies').length ? $('#map-agencies') : $('#map-detail')
    if ($c5.length) {
      $c5.waypoint(
        function () {
          agenciesMap.init($c5)
          this.destroy()
        },
        {
          offset: '100%'
        }
      )
    }
  })

  if ($('#go').length) {
    const t = $('#go')
    $('html, body').animate(
      {
        scrollTop: $(t).offset().top - $('#navigation4').height() - 50
      },
      500
    )
  }
})
